$(document).on('click','.menu-burger,.menu-drawer-close',function (e){
  e.preventDefault();
  $('body').toggleClass('menu-open');
});
$(document).on('click','.menu-drawer-close',function(e){
  e.preventDefault();
  $('body').removeClass('menu-open');
});
$(document).on('click','.mob_link',function(e){
  if($(this).parent('.md-liknkinr').next('.md-mega-menu').length){
    e.preventDefault();
    $(this).closest('li').addClass('subnav-open');
    $(this).parents('.menu-drawer-inner').addClass('nav-drawer');  
  }
});
$(document).on('click','.subnav-close',function(e){
  e.preventDefault();
  $(this).parents('li').removeClass('subnav-open');
  $(this).parents('.menu-drawer-inner').removeClass('nav-drawer');
});
$(document).on('click','.sub-liknkinr a',function(e){
  if($(this).parent('.sub-liknkinr').next('.grand-subnav').length || $(this).parent('.sub-liknkinr').next('.md-megaicon-column').length){
    e.preventDefault();
    $(this).closest('li').addClass('grand-subnav-open');
    $(this).parents('.menu-drawer-inner').addClass('subnav-drawer').removeClass('nav-drawer');
  }
});
$(document).on('click','.grand-subnav-close',function(e){
  e.preventDefault();
  $(this).parents('li').removeClass('grand-subnav-open');
  $(this).parents('.menu-drawer-inner').addClass('nav-drawer').removeClass('subnav-drawer');
});

$(document).on('click','.md-mega-hasicon',function(e){
  e.preventDefault();
  $(this).closest('.md-mega-column').addClass('iconbar-open');
  $(this).parents('.menu-drawer-inner').addClass('grandnav-drawer').removeClass('subnav-drawer');
});
$(document).on('click','.iconbar-close',function(e){
  e.preventDefault();
  $(this).parents('.md-mega-column').removeClass('iconbar-open');
  $(this).parents('.menu-drawer-inner').removeClass('grandnav-drawer');
});
// logo shrink
let original_header = $('.shopify-section-group-header-group').innerHeight();
$(document).on("scroll", function(){
  var scrollCount = $(document).scrollTop(); 
  if(window.innerWidth > 1440){
    var logoHeight = parseInt($('.desk-logo').attr('data-max'));
  }else if(window.innerWidth > 1199){
    var logoHeight = 135;
  }else if(window.innerWidth > 991){
    var logoHeight = 75;
  }else if(window.innerWidth > 374){
    var logoHeight = 73;
  }else if(window.innerWidth > 319){
    var logoHeight = 67;
  }
  var header = $('.shopify-section-group-header-group').innerHeight();
  if(scrollCount > 0){
    $('main').css('margin-top',header+'px');
  }else{
    $('main').css('margin-top',original_header+'px'); 
  }
  if(scrollCount <= (logoHeight * 3)){
    logoHeight = logoHeight - (scrollCount / 3);
    $('header').removeClass('sticky-header')
    if(parseInt($('.desk-logo').attr('data-min')) <= logoHeight){
      $('.logo svg').css("height", logoHeight+'px');
      $('header').removeClass('sticky-header');
    }else{
      $('header').addClass('sticky-header');
      $('.logo svg').css('height',parseInt($('.desk-logo').attr('data-min')+'px'));
    }
  }else{
    $('header').addClass('sticky-header');
  }
});
$(window).on('load',function(){
  var scrollCount = $(document).scrollTop();
  if(scrollCount > 100){
    $('.logo svg').css("height", '43px');
  }
})
$(document).ready(function(){
  var scrollCount = $(document).scrollTop();
  if(scrollCount > 100){
    $('.logo svg').css("height", '43px');
  }
})
function quoteCount(){
  var count = (($('.grfq-quote-widget-label a').text().split('(')).pop()).replace(')','');
  if(count > 0){
    $('.header-cart-icon .cart-bubble').text(count);
    $('.header-cart-icon .cart-bubble').addClass('active');
    $('.mb-nav-quote').text('Quote (' + count + ')');
  }
}
$(document).ready(function(e){
  $('main').css('margin-top',$('header').innerHeight()+'px');
  quoteCount();
  if($('body').length > 0){
    var scrolltop = $(window).scrollTop();
    var logo = $('.header-logo svg').innerHeight();
    if(scrolltop > logo || !($('header').hasClass('sticky-header')) || scrolltop == 0){
      $('body').removeClass('largeSVG');
    }else{
      $('body').addClass('largeSVG');
    }
  };
});
$(window).on('resize',function(){
  $('main').css('margin-top',$('header').innerHeight()+'px');
})
$(window).on('load',function(){
  $('main').css('margin-top',$('header').innerHeight()+'px');
  quoteCount();
});
$(document).on('click','.grfq-item-quantity-button',function(){
  quoteCount();
});
$(document).on('click','.grfq-variant-quantity-icon',function(){
  console.log('click');
  if($('.rfq_form_page').find('.grfq-quote-empty').length){
    $('.header-cart-icon .cart-bubble').text('0');
    $('.header-cart-icon .cart-bubble').removeClass('active');
    $('.mb-nav-quote').text('Quote (0)');
  }
});